import { useEffect, useState } from "react";
import { api } from "../../lib/apiClient";
import {
  PageHead, Card, Pill, StatusPill, FilterBar, Select, Loading, Err, tableStyles, EmptyState,
} from "./_shared";

const SOURCES = ["all", "audit", "system_events", "jobs"];

export default function Activity() {
  const [items, setItems] = useState(null);
  const [err, setErr] = useState("");
  const [source, setSource] = useState("all");

  useEffect(() => {
    api.get("/api/admin/activity" + (source && source !== "all" ? `?source=${source}` : ""))
      .then((d) => setItems(d.items || [])).catch((e) => setErr(e.message));
  }, [source]);

  if (err) return <Err msg={err} />;

  return (
    <div data-testid="admin-activity">
      <PageHead title="Activity" sub="Unified stream of audit logs, system events, and job activity" />

      <FilterBar>
        <Select value={source} onChange={setSource} placeholder="All sources" options={SOURCES} data-testid="activity-filter-source" />
      </FilterBar>

      {!items ? <Loading /> : items.length === 0 ? (
        <EmptyState title="No activity yet" description="Once admins act on workspaces or jobs run through the worker, the activity stream will populate here." />
      ) : (
        <Card pad={0} style={{ overflow: "hidden" }}>
          <table style={tableStyles.table}>
            <thead>
              <tr>
                <th style={tableStyles.th}>When</th>
                <th style={tableStyles.th}>Source</th>
                <th style={tableStyles.th}>Type / Action</th>
                <th style={tableStyles.th}>Actor</th>
                <th style={tableStyles.th}>Resource</th>
                <th style={tableStyles.th}>Status</th>
              </tr>
            </thead>
            <tbody>
              {items.map((a, i) => (
                <tr key={a.id || `${a.source}-${i}`} data-testid={`activity-row-${i}`} style={{ borderTop: "1px solid var(--pl-border)" }}>
                  <td style={{ ...tableStyles.td, fontSize: 11 }}>{(a.created_at || "").slice(0, 19)}</td>
                  <td style={tableStyles.td}><Pill>{a.source}</Pill></td>
                  <td style={{ ...tableStyles.td, fontWeight: 700 }}>{a.label}</td>
                  <td style={{ ...tableStyles.td, fontFamily: "JetBrains Mono, monospace", fontSize: 11 }}>{(a.actor || "—").slice(0, 16)}</td>
                  <td style={{ ...tableStyles.td, fontFamily: "JetBrains Mono, monospace", fontSize: 11 }}>{(a.resource || "—").slice(0, 24)}</td>
                  <td style={tableStyles.td}>{a.status ? <StatusPill s={a.status} /> : "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </Card>
      )}
    </div>
  );
}
